module.exports = {"title":"Privacy Policy","content":"Privacy Policy","link":{"default":"https://karamba.com/info/privacy"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/privacy.json
// module id = 654
// module chunks = 247 1437